import {translate} from '../i18n/translate.js';


export const CATEGORY_QRY = "#Tab";
export const ITEM_QRY = "#item";
export const CART_ITEM_QRY = "#cart";

export const ORIGIN_CATEGORY_SELECTED = 0;
export const ORIGIN_ITEM_SELECTED = 1;

export const FIELD_SELECTED_ORDER = "__selected_order__";
export const FIELD_ADDITIONAL_ITEM_QTY = "__additional_qty__";

export const GENERIC_ERROR_MESSAGE = translate("FatalError.text");

export const LOG_IN_MESSAGE = '_LoginToStart';
export const NOT_USED_ALL_CREDITS_MESSAGE = translate("creditNotUsed");

export const DELIVERY_HOLD_OVERLAP_ERROR = translate("enterValidVacationRangeNotOverlap");
export const DELIVERY_HOLD_DATES_IN_PAST_ERROR = translate("enterFutureVacationPeriod");
export const DELIVERY_HOLD_DATES_END_BEFORE_START_DATE_ERROR = translate("enterValidVacationRange");
export const DELIVERY_HOLD_DATES_VACATION_CANNOT_BE_APPLIED = translate("noChangeAllowedVacation");
export const DELIVERY_HOLD_DATES_CANCEL_ORDER = translate("_OrderScheduledDuringTheseDates");
export const DELIVERY_HOLD_RECURRING_ORDERS_ALERT = translate("deliveryHoldResetRecurringOrders");
export const DELIVERY_HOLD_DATES_BLOCK_DATE_NO_BALANCE = translate("cantAcceptVacationChangeActiveOrder");

export const INVALID_SEND_EMAIL_PARTNER_MESSAGE = translate("sendEmailsRequiresFields");
export const INVALID_PHONE_NUMBER = translate("INVALID_PHONE_NUMBER");
export const INVALID_ADDRESS_HOME_DELIVERY = translate("INVALID_ADDRESS_HOME_DELIVERY");

export const NO_COOKIE_LOGIN = "Your browser is set to block any site data and therefore you cannot log in. Please adjust your browser settings, restart the page and try again.";
export const NO_COOKIE_CREATE = "Your browser is set to block any site data and therefore you cannot complete the process. Please adjust your browser settings, restart the page and try again.";
export const ORDER_KEY_CHANGED = translate("_refreshOrderDeleted");
export const PICKUP_SITE_KEY_CHANGED = translate("Something went wrong. Please refresh the page.");
export const UNAUTHORIZED_ACTION = "You are not authorized to take this action. Please login first";
export const GEOCODE_ERROR = "Oops... <br>Something went wrong...";
export const CIM_NOT_ENABLED = "Credit Card payments can't be processed now due to invalid configuration. Please select another payment method to complete your signup or contact the farm to set your account.";
export const CIM_NOT_ENABLED_ERROR_CODE = "E00044";
export const INVALID_USER_AUTHENTICATION_ERROR_CODE = "E00007";
export const SUBSCRIPTION_EXISTS_ERROR = "SubscriptionExists";
export const SUBSCRIPTION_EXISTS_ERROR_MESSAGE = "You already have a subscription for this season. Please refresh the browser.";
export const GOOGLE_UNDEFINED_ERROR_MESSAGE = "google is not defined";
export const OPERATION_ABORTED_ERROR_MESSAGE = "Operation aborted ";
export const OLD_VERSION_MESSAGE = "Session ended. Please reload the browser to continue";

export const CreditTypes = {
    'CREDIT_TYPE_REGULAR': 'RegularCredit',
    'CREDIT_TYPE_FARMIGO': 'FarmigoCredit',
    'CREDIT_BY_SHARE': 'shareCredit'
};
export const PaymentMethod = {
	CHECK: {key:"CHECK", title: translate("CHECK")},
	BALANCE: {key:"BALANCE", title: translate("BALANCE")},
	PAYPAL_PRO: {key:"PAYPAL_PRO", title: translate("todo")},
	PHONE: {key:"PHONE", title: translate("PHONE")},
	PAYPAL_STANDARD: {key:"PAYPAL_STANDARD", title: translate("PAYPAL_STANDARD")},
	PAYPAL_PREAPPROVE: {key:"PAYPAL_PREAPPROVE", title: translate("PAYPAL_PREAPPROVE"), shortTitle:translate("PayPal")},
	ELECTRONIC_CHECK: {key:"ELECTRONIC_CHECK", title: translate("ELECTRONIC_CHECK")},
	ELECTRONIC_CHECK_PREAPPROVE: {key:"ELECTRONIC_CHECK_PREAPPROVE", title: translate("ELECTRONIC_CHECK_PREAPPROVE"), shortTitle: translate("Electronic Check")},
	AUTHORIZE_DOT_NET: {key:"AUTHORIZE_DOT_NET", title: translate("AUTHORIZE_DOT_NET")},
	AUTHORIZE_DOT_NET_PREAPPROVE: {key:"AUTHORIZE_DOT_NET_PREAPPROVE", title: translate("AUTHORIZE_DOT_NET_PREAPPROVE"), shortTitle: translate("Debit/Credit Card")},
	EBT_ONLINE: {key:"EBT_ONLINE", title: translate("EBT Online")},
	CASH: {key:"CASH", title: translate("CASH")},
	NONE: {key:"NONE", title: translate("NONE")}
};

export const PaymentMethodsSinglePayment = [PaymentMethod.PAYPAL_STANDARD.key,
    PaymentMethod.ELECTRONIC_CHECK.key, PaymentMethod.CHECK.key, PaymentMethod.AUTHORIZE_DOT_NET.key, PaymentMethod.EBT_ONLINE.key];

export const PaymentMethodsAutoPayment = [PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key,
    PaymentMethod.PAYPAL_PREAPPROVE.key, PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key];

export const URLs = {
    'STORE': 'store',
    'JOIN': 'join',
    'ACCOUNT': 'account',
    'PAY': 'pay',
    'CHARGE': 'charge'
};

export const PaymentPlans = {
    'F': 'F', //"Full Payment"
    'P': 'P', //"Pre Payment"
    'DynamicPrePayment': 'DynamicPrePayment',
    'CustomPrePayment': 'CustomPrePayment',
    'D': 'D', //"Dynamic"
    'R': 'R', //"Recurring"
    'AutoRecurring': 'AutoRecurring',
    'FullWithDeposit': 'FullWithDeposit',
    'PresetRecurring': 'PresetRecurring',
    'OneWeekDebit': 'OneWeekDebit',
    'DistributionDynamicPrePayment': 'DistributionDynamicPrePayment'
};

export const PaymentPlansSinglePayment = [PaymentPlans.DistributionDynamicPrePayment,
    PaymentPlans.CustomPrePayment, PaymentPlans.P, PaymentPlans.DynamicPrePayment];

export const PaymentPlansAutoPayment = [PaymentPlans.DistributionDynamicPrePayment,
    PaymentPlans.P, PaymentPlans.DynamicPrePayment, PaymentPlans.OneWeekDebit];

export const PaymentPlanRestrictions = {
    'F': ["PAYPAL_STANDARD", "ELECTRONIC_CHECK","AUTHORIZE_DOT_NET","CHECK", "PHONE", "EBT_ONLINE"],
    'P': ["PAYPAL_STANDARD","PAYPAL_PREAPPROVE", "ELECTRONIC_CHECK","ELECTRONIC_CHECK_PREAPPROVE", "AUTHORIZE_DOT_NET","AUTHORIZE_DOT_NET_PREAPPROVE","CHECK", "PHONE", "EBT_ONLINE"],
    'DynamicPrePayment': ["PAYPAL_STANDARD","PAYPAL_PREAPPROVE","ELECTRONIC_CHECK","ELECTRONIC_CHECK_PREAPPROVE", "AUTHORIZE_DOT_NET","AUTHORIZE_DOT_NET_PREAPPROVE","CHECK", "PHONE", "EBT_ONLINE"],
    'CustomPrePayment': [],//not an option in signup
    'D': ["PAYPAL_STANDARD","PAYPAL_PREAPPROVE","ELECTRONIC_CHECK","ELECTRONIC_CHECK_PREAPPROVE", "AUTHORIZE_DOT_NET","AUTHORIZE_DOT_NET_PREAPPROVE","CHECK", "PHONE", "EBT_ONLINE"],
    'R': [],
    'AutoRecurring': ["PAYPAL_PREAPPROVE","ELECTRONIC_CHECK_PREAPPROVE","AUTHORIZE_DOT_NET_PREAPPROVE","CHECK","PHONE"],
    'PresetRecurring': ["PAYPAL_PREAPPROVE","ELECTRONIC_CHECK_PREAPPROVE","AUTHORIZE_DOT_NET_PREAPPROVE","CHECK","PHONE"],
    'OneWeekDebit': ["CASH","PAYPAL_PREAPPROVE","ELECTRONIC_CHECK_PREAPPROVE","AUTHORIZE_DOT_NET_PREAPPROVE"],
    'DistributionDynamicPrePayment': ["PAYPAL_STANDARD","PAYPAL_PREAPPROVE", "ELECTRONIC_CHECK","ELECTRONIC_CHECK_PREAPPROVE", "AUTHORIZE_DOT_NET","AUTHORIZE_DOT_NET_PREAPPROVE","CHECK", "PHONE", "EBT_ONLINE"]
};

export const FetchingTypes = {
    'LOAD_STORE_DATA': 'LoadStoreData',
    'LOAD_SIGNUP_DATA': 'LoadSignupData',
    'LOAD_SIGNUP_SHARES': 'LoadSignupShares',
    'LOAD_PICKUP_DATA': 'LoadPickupData',
    'GET_STATUS': 'GetStatus',
    'VALIDATE_COUPON': 'ValidateCoupon',
    'SUBMIT': 'Submit',
    'LOG_OUT': 'Logout',
    'LOGIN': 'Login',
    'LOAD_ACCOUNT_DATA': 'LoadAccountData',
    'LOAD_ORDER_DATA': 'LoadOrderData',
    'UPDATE_VACATION': 'UPDATE_VACATION',
    'UPDATE_PICKUP_SITE': 'UpdatePickupSite',
    'CHANGE_SUBSCRIPTION': 'ChangeSubscription',
    'CREATE_SUBSCRIPTION': 'CreateSubscription',
    'VALIDATE_UPDATE_MEMBER': 'ValidateUpdateMember',
    'UPDATE_LAT_LNG': 'UpdateLatLng',
    'SET_RECURRING_ORDER': 'SetRecurringOrder',
    'REMOVE_RECURRING_ORDER': 'RemoveRecurringOrder',
    'UPDATE_ITEM_AVAILABILITY': 'UpdateItemAvailability',
};

export const JoinSteps = {
	'PICKUP_SITES': 'PICKUP_SITES',
	'SHARES': 'SHARES',
	'OPTIONS': 'OPTIONS',
    'TERMS': 'TERMS',
    'CONTACT_INFO': 'CONTACT_INFO',
    'PAY': 'PAY',
    'FINISH': 'FINISH',
    'THANK_YOU': 'THANK_YOU'
};

export const JoinStepsDirections = {
    'NEXT': 'NEXT',
    "BACK": 'BACK'
};

export const JoinCreateAccountConstants = {
    'CREATE_CONTACT': "createContact",
    'LOGIN': "login",
    'CONTACT_DETAILS': "contactDetails"
};

export const PickupSiteSelectionTypes = {
    'LIST' : 'List',
    'MAP': 'Map'
};

export const MemberActions = {
    "NO_ACTION": "noAction",
    "VALIDATE_MEMBER_DETAILS": "validateMemberDetails"
};

export const PickupSiteTypes = {
    "HOME": "Home",
    "REGULAR":"Regular",
    "ZONE":"Zone"
};

export const AccountModes = {
    "VIEW" : "VIEW",
    "CHANGE_PICKUP_SITE": "CHANGE_PICKUP_SITE",
    "CHANGE_SUBSCRIPTION": "CHANGE_SUBSCRIPTION",
    "CHANGE_SUBSCRIPTION_THANKYOU": "CHANGE_SUBSCRIPTION_THANKYOU"
};

export const FarmBalanceTypes = {
    "BALANCE_ON_ACCOUNT":"BalanceOnAccount",
    "BALANCE_DUE":"BalanceDue"
};

export const OverviewHistoryTypes = {
    "HOLD": "Hold",
    "NEW": "New",
    "VACATION":"Vacation",
    "ORDER":"Order",
    "SUBSCRIPTION":"Subscription",
    "PAYMENT":"Payment",
    "REJECTED_PAYMENT":"RejectedPayment",
    "PENDING_PAYMENT":"PendingPayment",
    "FEE":"Fee",
    "REFUND":"Refund",
    "FARMIGO_CREDITS":"FarmigoCredits"
};

export const JoinModes = {
    "NEW": "New",
    "CHANGE": "Change",
    "ADD": "Add"
};

export const SubscriptionStatuses = {
    WAITLIST_SUBSCRIPTION: "WaitListSubscription",
    SUBSCRIPTION_EXISTS:"SubscriptionExists",
    NO_SUBSCRIPTION:"NoSubscription",
    HOLD_SUBSCRIPTION:"HoldSubscription",
    SUBSCRIPTION_CANCELED:"SubscriptionCanceled",
    NO_FUTURE_DELIVERIES:"NoFutureDeliveries",
    STORE_WAITLIST_SUBSCRIPTION:"StoreWaitListSubscription",
    PROCESSING_ORDER:"ProcessingOrder",
    PROCESSING_SUBSCRIPTION:"ProcessingSubscription",
    STORE_CLOSED:"StoreClosed",
    ROLLOVER_ENABLED:"RolloverEnabled"
};
export const SubscriptionHoldReason = {
    ADMIN: "ADMIN",
    NEW: "NEW",
    VACATION: "VACATION"
};
export const Messages = {
    WAITLIST_SUBSCRIPTION: {title:translate("_waitListSubscriptionTitle"),
        body: translate("_waitListSubscriptionBody")},
    SUBSCRIPTION_EXISTS:{title:translate("_subscriptionExistsTitle"),
        body:translate("_subscriptionExistsBody")},
    NO_SUBSCRIPTION: {title:translate("_noSubscriptionTitle"),
        // body:"In order to process your order, you must have an active subscription with the producer.</br>Please contact the producer or visit our web site to sign-up.",
        body:translate("_noSubscriptionBody"),
        linkText:translate("Create Account")},
    HOLD_SUBSCRIPTION: {
        ADMIN:{title:translate("_holdSubscription_ADMIN_title"),
            body:translate("_holdSubscription_ADMIN_body")},
        NEW:{title:translate("_holdSubscription_NEW_title"),
            body:translate("_holdSubscription_NEW_body")},
        VACATION:{title:translate("_holdSubscription_VACATION_title"),
            body:translate("_holdSubscription_VACATION_body"),
            linkText: translate('My Account')},
        VACATION_ALLOW_CHANGE:{title:translate("_holdSubscription_VACATION_AllowChangeTitle"),
            body:translate("_holdSubscription_VACATION_AllowChangeBody"),
            linkText: translate('My Account')}
        },
    SUBSCRIPTION_CANCELED: {title:translate("_subscriptionCanceledTitle"),
        body:translate("_subscriptionCanceledBody")},
    NO_FUTURE_DELIVERIES:{title:translate("_noFutureDeliveriesTitle"),
        body:translate("_noFutureDeliveriesBody")},
    STORE_WAITLIST_SUBSCRIPTION:{title:translate("_storeWaitListSubscriptionTitle"),
        body:translate("_storeWaitListSubscriptionBody")},
    PROCESSING_ORDER: {title:translate("_processingOrderTitle"),
        body:translate("_processingOrderBody")},
    STORE_CLOSED:{title:translate("Store Closed")}
};
export const PaymentTypes = {
    SINGLE_PAYMENT: {type:"single", label: translate("Make Single Payment"), shortLabel: translate("Make Payment")},
    AUTO_PAYMENT: {type: "auto", label: translate("Automatic Renewal Charges"), shortLabel: translate("Auto Charges")},
    UPDATE_PAYMENT: {type:"update", label: translate("Update Details"), shortLabel: translate("Update")},
    CHARGE: {type:"charge", label: translate("Charge"), shortLabel: translate("Charge")},
    PAYMENT_PLAN: {type:"plan", label: translate("Payment Plan"), shortLabel: ("Payment Plan")},
    PAYMENT_TOKEN: {type:"token", label: translate("Payment Token"), shortLabel: translate("Payment Token")}
};
export const CouponStatus = {
    NONE: 'NONE',
    VALID: 'VALID',
    INVALID: 'INVALID',
    VALIDATING: 'VALIDATING',
    INVALID_COUPON: "invalidCoupon",
    INVALID_COUPON_FIRST_USE: "NotFirstOrderOfSubscription",
    INVALID_COUPON_ALREADY_USE: "AlreadyUsedBySubscription",
    INVALID_COUPON_MINIMUM: "invalidSubscriptionMinCoupon",
    INVALID_COUPON_MINIMUM_WITH_OPTIONS: "invalidSubscriptionMinCouponWithOptions"
};


// WEBPACK FOOTER //
// ./src/common/constants.js